const GRAPHQL_ENDPOINT = 'https://getpov.app/graphql/v4';

export class GraphQLService {
    static async query(query, variables = {}) {
        console.log('GraphQL Request:', { query: query.trim(), variables });
        
        try {
            const response = await fetch(GRAPHQL_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    query,
                    variables
                })
            });

            console.log('GraphQL Response Status:', response.status);

            if (!response.ok) {
                const errorText = await response.text();
                console.error('HTTP Error Response:', errorText);
                throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
            }

            const data = await response.json();
            console.log('GraphQL Response Data:', data);
            
            if (data.errors) {
                console.error('GraphQL Errors:', data.errors);
                const errorMessage = data.errors.map(err => err.message).join(', ');
                throw new Error(errorMessage);
            }
            
            return data.data;
        } catch (error) {
            console.error('GraphQL Error Details:', {
                message: error.message,
                query: query.trim(),
                variables,
                error
            });
            throw error;
        }
    }

    static async getUserByUsername(username) {
        const query = `
            query GetUserByPovUsername($username: String!) {
                getUserByPovUsername(username: $username) {
                    first_name
                    username
                    profile_photo
                }
            }
        `;

        try {
            const data = await this.query(query, { username });
            const user = data.getUserByPovUsername;
            
            if (!user) {
                throw new Error('User not found');
            }

            // Transform to match expected format
            return {
                userId: username, // Using username as ID
                name: user.first_name,
                username: user.username.startsWith('@') ? user.username : `@${user.username}`,
                profilePhoto: user.profile_photo || 'https://images.unsplash.com/photo-1544723795-3fb6469f5b39?w=150&h=150&fit=crop&crop=face'
            };
        } catch (error) {
            console.error('Error fetching user by username:', error);
            throw error;
        }
    }

    static async getRandomVibesForUsername(username, limit = 4) {
        const query = `
            query GetRandomVibesForPov($username: String!, $limit: Int!) {
                getRandomVibesForPov(username: $username, limit: $limit) {
                    id
                    name
                    emoji
                    tag
                }
            }
        `;

        try {
            const data = await this.query(query, { username, limit });
            return data.getRandomVibesForPov || [];
        } catch (error) {
            console.error('Error fetching vibes for username:', error);
            throw error;
        }
    }

    static async sendAnonymousVibe(username, vibeId, senderName) {
        const mutation = `
            mutation SendAnonymousVibe($username: String!, $vibe_id: ID!, $sender_name: String!) {
                sendAnonymousVibe(username: $username, vibe_id: $vibe_id, sender_name: $sender_name) {
                    success
                    message
                }
            }
        `;

        try {
            const data = await this.query(mutation, { 
                username, 
                vibe_id: vibeId, 
                sender_name: senderName 
            });
            return data.sendAnonymousVibe;
        } catch (error) {
            console.error('Error sending vibe to username:', error);
            throw error;
        }
    }

    static async togglePovLink(userId) {
        const mutation = `
            mutation TogglePovLink($userId: String!) {
                togglePovLink(userId: $userId) {
                    success
                    message
                    is_active
                }
            }
        `;

        try {
            const data = await this.query(mutation, { userId });
            return data.togglePovLink;
        } catch (error) {
            console.error('Error toggling POV link:', error);
            throw error;
        }
    }

    // Utility function to extract slug from URL like "slug=p7c2gCXV7y"
    static extractSlugFromParam(slugParam) {
        if (!slugParam) return null;
        
        // Handle both formats: "slug=p7c2gCXV7y" or just "p7c2gCXV7y"
        if (slugParam.startsWith('slug=')) {
            return slugParam.substring(5);
        }
        return slugParam;
    }
}